const packageJsonInfo = require('../../package.json')

const versionDetails = packageJsonInfo.versionDetails

export default versionDetails
